import { render, staticRenderFns } from "./approval-task.vue?vue&type=template&id=3ea6901c"
import script from "./approval-task.vue?vue&type=script&lang=ts"
export * from "./approval-task.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports